import {
    buildSalesStartOptions,
    resolveSalesStartOption,
} from 'views/ProFormaTable/components/ProForma/ProFormaDisposition/helpers';
import { IDispositionData, IProFormaGeneralInfo, SaleFrequency } from 'views/ProFormaTable/types';
import { formatDate } from '../helpers';

export const formatLdSalesStart = (
    proForma: Pick<IProFormaGeneralInfo, 'constructionStart'>,
    disposition: Pick<IDispositionData, 'salesStart' | 'saleFrequency'> | undefined,
    developmentEndDate: string | null | undefined,
    includeDay = true,
): string => {
    if (disposition?.salesStart) {
        return formatDate(disposition.salesStart, includeDay);
    }

    const frequency: SaleFrequency = disposition?.saleFrequency === 'monthly' ? 'monthly' : 'quarterly';
    const options = buildSalesStartOptions(
        proForma.constructionStart,
        developmentEndDate,
        frequency,
    );
    const resolved = resolveSalesStartOption(options, null);
    if (!resolved?.value) return '';
    return formatDate(resolved.value, includeDay);
};
